// extracted by mini-css-extract-plugin
export default {"auditModal":"styles_auditModal__U-1H1","tableContaier":"styles_tableContaier__vjw44","modalTitle":"styles_modalTitle__2F1zN"};